export const UPLOAD_ACCEPT = ['application/pdf', 'image/jpeg', 'image/png'] as const

export const SIGNATURE_ACCEPT: readonly string[] = ['image/jpeg', 'image/png']

export const ZUWEISUNGSLISTE_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
export const ZUWEISUNGSLISTE_ACCEPT = ['.xlsx', ZUWEISUNGSLISTE_MIME] as const

export function isAllowedType(file: File, allowed: readonly string[]): boolean {
  return allowed.includes(file.type.toLowerCase()) || allowed.some((type) => type.startsWith('.') && file.name.toLowerCase().endsWith(type.toLowerCase()))
}

const TYPE_LABELS: Record<string, string> = {
  'application/pdf': 'PDF',
  '.pdf': 'PDF',
  'image/jpeg': 'JPG',
  'image/png': 'PNG',
  '.xlsx': 'XLSX',
  [ZUWEISUNGSLISTE_MIME]: 'XLSX',
}

export const readableUploadTypes = (accept: readonly string[]): string =>
  [...new Set(accept.map((type) => TYPE_LABELS[type] ?? type))].join(', ')
